import styled, { css } from "styled-components";

export const Box = styled.div`
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;

  background-color: rgba(0, 0, 0, 0.7);
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  flex-wrap: nowrap;
  z-index: 999;

  @media (max-width: 800px) {
    bottom: 6rem;
  }

  @media (max-width: 500px) {
    bottom: 8rem;
  }

  @media (max-width: 300px) {
    bottom: 12rem;
  }
`;

export const ImgContainer = styled.div`
  width: 50%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  flex-wrap: nowrap;
  background-color: transparent;
  padding: 2rem;
  border-radius: 1rem;
  gap: 2rem;
`;

export const ImgPopup = styled.img`

  width: 50rem;
  height: 50rem;
`

export const IconClose = styled.button`
  display: flex;
  background: unset;
  color: var(--hardRed);
  cursor: pointer;
  transition: all 0.3s ease;
  
  &:hover {
    transform: scale(1.1) rotate(180deg);
  }
`;